import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
} from 'reactstrap';
import React, { Component } from 'react';
import * as HelpMessages from '../../Services/helpMessages';
import { withTranslation } from 'react-i18next';

class HelpModal extends Component {
  getText = (location, purpose) => {
    if (purpose === 'applicantsHelp') {
      return this.applicantsHelp(location);
    } else if (purpose === 'applicationsHelp') {
      return this.applicationsHelp(location);
    } else if (purpose === 'jobsHelp') {
      return this.jobsHelp(location);
    } else if (purpose === 'competencesHelp') {
      return this.competencesHelp(location);
    } else if (purpose === 'jobCompetencesHelp') {
      return this.jobCompetencesHelp(location);
    } else if (purpose === 'dashboardHelp') {
      return this.dashboardHelp(location);
    } else if (purpose === 'settingsHelp') {
      return this.settingsHelp(location);
    } else if (purpose === 'calendarHelp') {
      return this.calendarHelp(location);
    } else
      return (
        <div>
          <Alert color="danger">Unknown purpose...</Alert>
        </div>
      );
  };

  state = {
    oneAtATime: true,
    accordionState: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
  };

  /* id is the index in the accordionState array */
  toggleAccordion = (id) => {
    let accordionState = this.state.accordionState.map((val, i) => {
      return id === i ? !val : this.state.oneAtATime ? false : val;
    });
    this.setState({
      accordionState,
    });
  };

  applicantsHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('common.APPLICANTS');
    } else if (location === 'body') {
      return (
        <div>
          <h3>
            <small>{HelpMessages.getApplicantsText(this.props.i18n.language)}</small>
          </h3>
          <h4>{HelpMessages.getApplicantsTitleText(this.props.i18n.language)}</h4>
          <ul>
            <li>{HelpMessages.getOpenApplicantsText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getBoundedApplicantsText(this.props.i18n.language)}</li>
          </ul>
          <h4 className="my-3 py-4 text-dark">{t('applicants.APPLICANTS_FAQ')}</h4>
          <Card className="b0 mb-2">
            <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(0)}>
              <CardTitle tag="h4">
                <a className="text-inherit">
                  <small>
                    <em className="fa fa-plus text-primary mr-2"></em>
                  </small>
                  {HelpMessages.getApplicantsQuestion1(this.props.i18n.language)}
                </a>
              </CardTitle>
            </CardHeader>
            <Collapse isOpen={this.state.accordionState[0]}>
              <CardBody>{HelpMessages.getApplicantsAnswer1(this.props.i18n.language)}</CardBody>
            </Collapse>
          </Card>
          <Card className="b0 mb-2">
            <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(1)}>
              <CardTitle tag="h4">
                <a className="text-inherit">
                  <small>
                    <em className="fa fa-plus text-primary mr-2"></em>
                  </small>
                  {HelpMessages.getApplicantsQuestion2(this.props.i18n.language)}
                </a>
              </CardTitle>
            </CardHeader>
            <Collapse isOpen={this.state.accordionState[1]}>
              <CardBody>{HelpMessages.getApplicantsAnswer2(this.props.i18n.language)}</CardBody>
            </Collapse>
          </Card>
          <Card className="b0 mb-2">
            <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(2)}>
              <CardTitle tag="h4">
                <a className="text-inherit">
                  <small>
                    <em className="fa fa-plus text-primary mr-2"></em>
                  </small>
                  {HelpMessages.getApplicantsQuestion3(this.props.i18n.language)}
                </a>
              </CardTitle>
            </CardHeader>
            <Collapse isOpen={this.state.accordionState[2]}>
              <CardBody>{HelpMessages.getApplicantsAnswer3(this.props.i18n.language)}</CardBody>
            </Collapse>
          </Card>
          <Card className="b0 mb-2">
            <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(3)}>
              <CardTitle tag="h4">
                <a className="text-inherit">
                  <small>
                    <em className="fa fa-plus text-primary mr-2"></em>
                  </small>
                  {HelpMessages.getApplicantsQuestion4(this.props.i18n.language)}
                </a>
              </CardTitle>
            </CardHeader>
            <Collapse isOpen={this.state.accordionState[3]}>
              <CardBody>{HelpMessages.getApplicantsAnswer4(this.props.i18n.language)}</CardBody>
            </Collapse>
          </Card>
        </div>
      );
    }
  };

  applicationsHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('menu.APPLICATIONS');
    } else if (location === 'body') {
      return (
        <div>
          <h3>
            <small>{HelpMessages.getApplicationsText(this.props.i18n.language)}</small>
          </h3>
          <h4>{HelpMessages.getApplicationsTitleText(this.props.i18n.language)}</h4>
          <ul>
            <li>{HelpMessages.getNormalApplicationsText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getJobAutomaticApplicationsText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getApplicantAutomaticApplicationsText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getFromCompetencesApplicationsText(this.props.i18n.language)}</li>
          </ul>
        </div>
      );
    }
  };

  jobsHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('menu.JOBS');
    } else if (location === 'body') {
      return (
        <div>
          <h4>{HelpMessages.getJobsTitleText(this.props.i18n.language)}</h4>
          <ul>
            <li>{HelpMessages.getOpenJobsText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getBoundedJobsText(this.props.i18n.language)}</li>
          </ul>
          <h4 className="my-3 py-4 text-dark">{t('jobs.JOBS_FAQ')}</h4>
          <Card className="b0 mb-2">
            <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(0)}>
              <CardTitle tag="h4">
                <a className="text-inherit">
                  <small>
                    <em className="fa fa-plus text-primary mr-2"></em>
                  </small>
                  {HelpMessages.getJobsQuestion1(this.props.i18n.language)}
                </a>
              </CardTitle>
            </CardHeader>
            <Collapse isOpen={this.state.accordionState[0]}>
              <CardBody>
                <CardBody>{HelpMessages.getJobsAnswer1(this.props.i18n.language)}</CardBody>
              </CardBody>
            </Collapse>
          </Card>
          <Card className="b0 mb-2">
            <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(1)}>
              <CardTitle tag="h4">
                <a className="text-inherit">
                  <small>
                    <em className="fa fa-plus text-primary mr-2"></em>
                  </small>
                  {HelpMessages.getJobsQuestion2(this.props.i18n.language)}
                </a>
              </CardTitle>
            </CardHeader>
            <Collapse isOpen={this.state.accordionState[1]}>
              <CardBody>{HelpMessages.getJobsAnswer2(this.props.i18n.language)}</CardBody>
            </Collapse>
          </Card>
          <Card className="b0 mb-2">
            <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(2)}>
              <CardTitle tag="h4">
                <a className="text-inherit">
                  <small>
                    <em className="fa fa-plus text-primary mr-2"></em>
                  </small>
                  <span>{HelpMessages.getCompetencesQuestion1(this.props.i18n.language)}</span>
                </a>
              </CardTitle>
            </CardHeader>
            <Collapse isOpen={this.state.accordionState[2]}>
              <CardBody>{HelpMessages.getCompetencesAnswer1(this.props.i18n.language)}</CardBody>
            </Collapse>
          </Card>
        </div>
      );
    }
  };

  dashboardHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('menu.DASHBOARD');
    } else if (location === 'body') {
      return <div>{HelpMessages.getDashboardDescriptionText(this.props.i18n.language)}</div>;
    }
  };

  settingsHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('menu.SETTINGS');
    } else if (location === 'body') {
      return <div>{HelpMessages.getSettingsDescriptionText(this.props.i18n.language)}</div>;
    }
  };

  calendarHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('menu.CALENDAR');
    } else if (location === 'body') {
      return <div>{HelpMessages.getCalendarDescriptionText(this.props.i18n.language)}</div>;
    }
  };

  competencesHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('menu.COMPETENCES');
    } else if (location === 'body') {
      return (
        <div>
          <h3>
            <small>{HelpMessages.getCompetencesDescriptionText(this.props.i18n.language)}</small>
          </h3>
          <h4>{HelpMessages.getCompetencesTitleText(this.props.i18n.language)}</h4>
          <ul>
            <li>{HelpMessages.getNormalCompetencesText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getBoolenCompetencesText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getInverseCompetencesText(this.props.i18n.language)}</li>
          </ul>
          {this.competencesFaq(t)}
        </div>
      );
    }
  };

  jobCompetencesHelp = (location) => {
    const { t } = this.props;
    if (location === 'header') {
      return t('menu.COMPETENCES');
    } else if (location === 'body') {
      return (
        <div>
          <h3>
            <small>{HelpMessages.getCompetencesDescriptionText(this.props.i18n.language)}</small>
          </h3>
          <h4>{HelpMessages.getCompetencesTitleText(this.props.i18n.language)}</h4>
          <ul>
            <li>{HelpMessages.getNormalCompetencesText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getBoolenCompetencesText(this.props.i18n.language)}</li>
            <li>{HelpMessages.getInverseCompetencesText(this.props.i18n.language)}</li>
          </ul>
          {this.competencesFaq(t)}
        </div>
      );
    }
  };

  competencesFaq = (t) => {
    <>
      <h4 className="my-3 py-4 text-dark">{t('competences.COMPETENCES_FAQ')}</h4>
      <Card className="b0 mb-2">
        <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(0)}>
          <CardTitle tag="h4">
            <a className="text-inherit">
              <small>
                <em className="fa fa-plus text-primary mr-2"></em>
              </small>
              <span>{HelpMessages.getCompetencesQuestion1(this.props.i18n.language)} </span>
            </a>
          </CardTitle>
        </CardHeader>
        <Collapse isOpen={this.state.accordionState[0]}>
          <CardBody>{HelpMessages.getCompetencesAnswer1(this.props.i18n.language)} </CardBody>
        </Collapse>
      </Card>
      <Card className="b0 mb-2">
        <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(1)}>
          <CardTitle tag="h4">
            <a className="text-inherit">
              <small>
                <em className="fa fa-plus text-primary mr-2"></em>
              </small>
              <span>{HelpMessages.getCompetencesQuestion2(this.props.i18n.language)} </span>
            </a>
          </CardTitle>
        </CardHeader>
        <Collapse isOpen={this.state.accordionState[1]}>
          <CardBody>{HelpMessages.getCompetencesAnswer2(this.props.i18n.language)} </CardBody>
        </Collapse>
      </Card>
      <Card className="b0 mb-2">
        <CardHeader style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(2)}>
          <CardTitle tag="h4">
            <a className="text-inherit">
              <small>
                <em className="fa fa-plus text-primary mr-2"></em>
              </small>
              <span>{HelpMessages.getCompetencesQuestion3(this.props.i18n.language)} </span>
            </a>
          </CardTitle>
        </CardHeader>
        <Collapse isOpen={this.state.accordionState[2]}>
          <CardBody>{HelpMessages.getCompetencesAnswer3(this.props.i18n.language)} </CardBody>
        </Collapse>
      </Card>
    </>;
  };

  render() {
    const { t } = this.props;
    // NOTE: Useful if you want to add "Info icon". For other cases just use UncontrolledTooltip
    return (
      <small>
        <em
          style={{ cursor: 'pointer' }}
          className="fa mr-2 fas fa fa-question-circle text-muted"
          onClick={() => this.props.onToggle()}
        >
          <Modal isOpen={this.props.showModal} size="lg" centered>
            <ModalHeader>
              <em className="fa-2x fas fa fa-question-circle"> {this.getText('header', this.props.purpose)}</em>
            </ModalHeader>
            <ModalBody>{this.getText('body', this.props.purpose)}</ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={() => this.props.onToggle()}>
                {t('common.OK')}
              </Button>
            </ModalFooter>
          </Modal>
        </em>
      </small>
    );
  }
}

export default withTranslation('translations')(HelpModal);
